<template>
  <div class="footer mt-5">
    <div class="mb-3">
      UserEvidence is a survey research firm, used by vendors like {{ this.account_name }} to gain
      valuable insights from their users. If results of the survey are published, your responses
      will be anonymous, unless you explicitly agree to share your name. UserEvidence will not share
      your contact information with any 3rd-parties.
    </div>
    <div class="mb-3">
      View our
      <a :href="privacy_page_url" target="blank">&nbsp;Privacy Policy</a>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: ['account_name'],
  computed: {
    privacy_page_url() {
      return `${process.env.VUE_APP_UE_WWW_URL}/privacy`
    },
  },
}
</script>
